module.exports = __webpack_public_path__ + "static/media/c12_9.0d1fbe69.png";